import { useState } from 'react';
import Modal from '../../../components/modal/Modal';
import { useFundDispatch } from '../../../contexts/FundContext';
import { useDict } from '../../../contexts/LanguageContext';
import { useStatusModalContext } from '../../../contexts/StatusModalContext';
import { postSubmitWithdrawal } from '../src/fundApis';

const WithdrawalConfirmModal = ({ withdrawalRequest, handleClose, isOpen }) => {
    const dict = useDict();

    const fundDispatch = useFundDispatch();
    const { openStatusModal } = useStatusModalContext();

    const [isLoading, setIsLoading] = useState(false);

    // const { mutate: submitWithdrawal } = useMutation(
    //     'submit-withdrawal',
    //     postSubmitWithdrawal,
    //     {
    //         onMutate: () => {
    //             toggleLoading();
    //             setIsLoading(true);
    //         },
    //         onSuccess: () => {
    //             handleClose(); // Close withdrawal confirmation modal
    //             openStatusModal({
    //                 title: 'Withdraw',
    //                 message:
    //                     'Your withdrawal was successful! Please allow 3 business days for it to be processed.',
    //                 refresh: true,
    //                 isSuccess: true,
    //             });
    //         },
    //         onError: (error) => {
    //             let errMessage = '';
    //             if (
    //                 error?.response?.data?.data &&
    //                 error?.response?.data?.data?.amount
    //             ) {
    //                 if (
    //                     error.response.data.data.amount[0] ===
    //                     'amount exceeds the available balance'
    //                 ) {
    //                     errMessage = 'Insufficient Balance.';
    //                 } else if (
    //                     error.response.data.data.amount[0] ===
    //                     'Minimum amount is 1.00.'
    //                 ) {
    //                     errMessage =
    //                         'The minimum amount of withdrawal is RM 1.00';
    //                 } else {
    //                     errMessage =
    //                         'Opps! Something wrong here. Your withdrawal was ' +
    //                         'unsuccessfully. Please try again or contact the administrator.';
    //                 }
    //             } else {
    //                 errMessage =
    //                     'Opps! Something wrong here. Your withdrawal was ' +
    //                     'unsuccessfully. Please try again or contact the administrator.';
    //             }
    //             Log.captureException(error, 'submitWithdrawalSaga', errMessage);
    //             handleClose(); // close confirmation modal
    //             openStatusModal({
    //                 title: 'Withdraw',
    //                 message: errMessage,
    //                 refresh: false,
    //                 isSuccess: false,
    //             });
    //         },
    //         onSettled: () => {
    //             toggleLoading();
    //             setIsLoading(false);
    //         },
    //     }
    // );

    const handleSubmitWithdrawal = () => {
        setIsLoading(true);

        postSubmitWithdrawal(withdrawalRequest, handlePostSubmitWithdrawal, handlePostSubmitWithdrawalError);

        setIsLoading(false);
    };

    const handlePostSubmitWithdrawal = () => {
        openStatusModal({
            message: dict.withdrawalSuccessfulMessage,
            title: dict.withdraw,
            isSuccess: true,
            refresh: true,
        });

        // if (!withdrawalRequest) {
        //     openStatusModal({
        //         title: 'Withdraw',
        //         message: 'Opps! Something went wrong here. Please try again.',
        //         refresh: false,
        //         isSuccess: false,
        //     });
        //     return;
        // }
        // const formData = new FormData();
        // formData.append('user_account_bank_id', withdrawalRequest.acc_bank_id);
        // const strAmount = parseAmountStr(
        //     withdrawalRequest.withdraw_amount.substring(3)
        // );
        // formData.append('amount', strAmount);
        // formData.append('send_email', '1');
        // formData.append(
        //     'withdrawal_reason_id',
        //     withdrawalRequest.reason_withdrawal.toString()
        // );
        // if (withdrawalRequest.reason_withdrawal === WithdrawReason.Other) {
        //     formData.append(
        //         'description',
        //         withdrawalRequest?.description || ''
        //     );
        // } else {
        //     formData.append('description', '');
        // }

        // submitWithdrawal(formData);
    };

    const handlePostSubmitWithdrawalError = (error) => {
        openStatusModal({
            title: dict.withdraw,
            message: dict.withdrawalFailedMessage,
            refresh: false,
            isSuccess: false,
        });
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            onCancel={handleClose}
            onSubmit={handleSubmitWithdrawal}
            cancelText={dict.cancel}
            submitText={dict.confirm}
            title={dict.withdrawal}
            headerType="invest-withdrawal"
            submitBtnProps={{
                disabled: isLoading,
            }}
            testID="withdrawalConfirmModal"
            submitShown
        >
            <div className="modal__body" style={{ textAlign: 'center' }}>
                <div data-cy="withdraw__confirmation" className="mx-auto">
                    <p>{dict.withdrawConfirmation}</p>
                </div>
            </div>
        </Modal>
    );
};

export default WithdrawalConfirmModal;
